import { initReact } from '../../../Shared/js/vendor/react';
import * as BroadbandComponents from './components';

function initBroadbandComponents() {
    initReact();
    window.BroadbandComponents = window.BroadbandComponents || BroadbandComponents;
}

initBroadbandComponents();
